/**
 * Milk Management Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const milkRoutes: RouteRecordRaw[] = [
  {
    path: '/milk',
    name: 'milk-pools',
    component: () => import('./views/MilkPoolsListView.vue'),
    meta: {
      title: () => i18next.t('nav.milk'),
      requiredEntitlement: 'MILK_MANAGEMENT',
      breadcrumbs: [{ label: () => i18next.t('nav.milk') }],
    },
  },
];
